import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";
import { FAQDetail } from "@/components"
import { linkResolver } from "@/prismicio";
import _ from 'lodash'

/**
 * Props for `Faq`.
 */
export type FaqProps = SliceComponentProps<Content.FaqSlice>;

/**
 * Component for "Faq" Slices.
 */
const Faq: FC<FaqProps> = ({ slice, context }) => {

  const contextData = context as any
  const allTags = _.flatMap(slice.primary.faq_list, (item: any) => item.faq_list?.tags || []);
  const uniqueTags = _.uniq(allTags);
  const filterList = uniqueTags.length > 2 ? uniqueTags : [];

  const validIds = slice.primary.faq_list.map((item: any) => item.faq_list.id);
  let filteredFaqData = validIds
    .map((id: string) => contextData?.faqs?.find((item: any) => item.id === id))
    .filter(Boolean);

  if(!contextData?.faqs)  {
    filteredFaqData = slice.primary.faq_list.map((item: any) => item.faq_list);
  }

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`${slice.primary.style === true ? "bg-lightgrey py-12" : ""} font-fellix md:py-12 px-4 md:px-12 lg:px-16`}
    >
      <div className={`${slice.primary.style === true ? "faq grey": "faq"} max-w-[750px] mx-auto`}>
        <div>
          <article className="text-[32px] leading-[34px] md:text-[48px] md:leading-[60px] font-semibold text-center mb-[63px] prose-h5:text-[28px] prose-h5:leading-[36px] prose-h5:font-semibold prose-h5:mt-[90px] prose-h5:mx-[0] prose-h5:mb-[50px]">
            <PrismicRichText field={slice.primary.title} linkResolver={linkResolver} />
          </article>
          <article className="text-lg leading-[24px] md:text-[28px] md:leading-[36px] font-normal text-center ] mt-[0] mx-[auto] mb-[47px] px-12">
            <PrismicRichText field={slice.primary.introduction} linkResolver={linkResolver} />
          </article>
          {filterList && (
          <div className="filters">
            <ul>
                {filterList.map((item: any, index: number)=> {
                  return (
                    <li className={"filter "+ item.toLowerCase().replace(/ /g, "-")} key={index}>{item}</li>
                  )
                })}
            </ul>
          </div>)}
          <div className="accordian">
            {filteredFaqData?.map((item: any, index: any)=>{
               if(item?.data?.question) {
              return (
                  <div key={index}>
                      <FAQDetail faqData={item}/>
                  </div>
                )
              }
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
